// build special object to merge with the account metadata
let getAbTestObj = (profile) => {
  let tests = profile.business.ab_test
  let testObj = {}
  Object.keys(tests).forEach((testName) => {
    let testValue = tests[testName]
    // remove false values
    if (testValue){
      testObj["ab_test_"+testName] = testValue
    }
  })
  return testObj
}

let getVisitorMetaData = (profile, isStar, isMobile, isImpersonate) => {
  let metadata = {
    id: 'PU-' + profile.staff.uid,
    email: profile.staff.email,
    role: profile.staff.role,
    full_name: profile.staff.full_name,
    first_name: profile.staff.first_name,
    last_name: profile.staff.last_name,
    locale: profile.settings.locale,
    user_type: profile.analytics_information.people_properties["User Type"],
    is_impersonate: isImpersonate
  }

  if (isStar) {
    let visitor_id;
    if (profile.brand.frontage_host.includes("thryvbeta"))
      visitor_id = `beta-(${profile.staff.uid})`
    else if (profile.brand.frontage_host.includes("emp.thryv"))
      visitor_id = `employee-(${profile.staff.uid})`
    else
      visitor_id = profile.staff.uid

    metadata = Object.assign(metadata,{
      id:                   visitor_id,
      has_password:         profile.staff.has_password,
      mobile_number:        profile.staff.mobile_number,
      mobile:               isMobile,
      user_id:              profile.business.uid,
      businessName:         profile.business.name,
      package:              profile.business.package
    })
  }

  return metadata
}

let getAccountMetaData = (profile, isStar, matterTerm, numOfStaff) => {
  let date =  new Date(profile.business.created_at).toLocaleDateString("en-US")
  if (isStar) {
    return {
      id:                   profile.business.uid,
      businessName:         profile.business.name,
      creationDateTime:     profile.business.created_at,
      creationDate:         date,
      phoneNumber:          profile.business.phone,
      address:              profile.business.address,
      package:              profile.business.package,
      hasLogo:              !!profile.business.photo_path,
      tags:                 profile.tags,
      on_trial:             profile.business.on_trial,
      business_identities:  profile.business.content_manager_identities_uids,
      matter_term: matterTerm,
      thryvPayConnected:    profile.settings["external_Thryv Pay Production_connected"] || profile.settings["external_ThryvPay_connected"]
    }
  }
  else
  // megre ab-test object with metadata object
    return {...{
        id: 'P-' + profile.business.uid,
        creation_date_time: profile.business.created_at,
        creation_date: new Date(profile.business.created_at).toISOString(),
        business_name: profile.business.name,
        business_identities:  profile.business.identities_name,
        profession: profile.settings.profession && profile.settings.profession.text,
        locale: profile.settings.locale,
        expired: profile.notifications.account_blocked,
        marketing_channel: profile.business.marketing_channel && profile.business.marketing_channel.toLowerCase(),
        marketing_referrer: profile.business.marketing_referrer && profile.business.marketing_referrer.toLowerCase(),
        country: profile.business.country_name,
        directory_name: profile.brand.name,
        plan: profile.business.package_display_name,
        business_size: profile.business.info_business_size,
        intent: Object.keys(profile.business.onboarding_tiles).filter((key) => {if (profile.business.onboarding_tiles[key]) return key}),
        todo: profile.business.done_todo,
        sub_account: !profile.business.direct,
        matter_term: matterTerm,
        number_of_staff: numOfStaff,
        customer_success_owner: profile.business.customer_success_owner,
        payment_intents: Object.keys(profile.business.payment_intents).filter(key => profile.business.payment_intents[key] === 1),
        has_paid_apps: !!profile.business.features?.includes("paid_apps"),
        primary_payment_gateway: profile.settings.payments_gateway_type,
        has_bizai_chat: profile.business.features?.includes("bizai_chat"),
        allow_bank_debit_on_checkout: !!profile.settings.allow_bank_debit_on_checkout,
      }, ...getAbTestObj(profile)}
}



const buildPendo = (apiKey) => {
  if (!apiKey) return
    let script = `(function(apiKey){ (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[]; v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){ o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]); y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js'; z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo'); })('${apiKey}');`
    let pendoScript = document.createElement('script')
    pendoScript.innerHTML = script
    document.getElementsByTagName('head')[0].appendChild(pendoScript)
}

const initPendo = (profile, isStar, isMobile, matterTerm, numOfStaff, isImpersonate) => {
  if (window.pendo) {
    let visitor = getVisitorMetaData(profile, isStar, isMobile, isImpersonate)
    let account = getAccountMetaData(profile, isStar, matterTerm, numOfStaff)
    window.pendo.initialize({visitor, account})
  }
}


export default {
  buildPendo,
  initPendo
};





